import { withJsonFormsControlProps } from '@jsonforms/react';
import { File } from './File';

const FileControl = ({ data, handleChange, path, schema, errors, visible }) => {
  return (
    <File
      value={data}
      updateValue={(newValue) => handleChange(path, newValue)}
      path={path}
      description={schema?.description ?? ''}
      errors={errors}
      visible={visible}
    />
  );
};

export default withJsonFormsControlProps(FileControl);
